var i = /* @__PURE__ */ ((a) => (a.Email = "email", a.SMS = "sms", a.TwoFA = "2fa", a))(i || {});
export {
  i as SenderTypeEnum
};
//# sourceMappingURL=otp.js.map
